// mobile 에서 html style에 overflow-y 가 hidden으로 되어있으면
// pull to refresh 가 적용 안됨.
// 따라서 해당 함수를 통해 true 값이 변수로 온다면 overflow-hidden 을 주어서
// 특정 상황에서는 html에 scroll이 적용되지않도록 한다.

function preventScroll(available: boolean): void {
  if (document.scrollingElement !== null) {
    const scrollElm = document.scrollingElement;
    if (available) {
      scrollElm.setAttribute('style', 'overflow-y: hidden');
    } else {
      scrollElm.setAttribute('style', '');
    }
  }
}

export default preventScroll;
